import * as React from "react";

const ErrorIcon: React.FC = () => {
    return (
        <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.3481 15.8158L12.3456 0.447004C12.1618 0.169073 11.8431 0 11.5005 0C11.157 0 10.8383 0.169069 10.6545 0.447004L0.652008 15.8158C0.457058 16.1152 0.449327 16.4929 0.630537 16.8005C0.812604 17.1073 1.15527 17.2937 1.52284 17.2855H21.5279C21.886 17.2764 22.2124 17.0826 22.3816 16.7791C22.5507 16.4756 22.5379 16.1077 22.3481 15.8158L22.3481 15.8158ZM12.525 14.4038H10.5248V12.4831H12.525V14.4038ZM12.525 10.5615H10.5248V5.75914H12.525V10.5615Z"
                fill="#AC1E2D"
            />
        </svg>
    );
};

export default React.memo(ErrorIcon);
